<template>
    <div>
        <el-form ref="form"
                 :model="form"
                 label-width="120px"
                 @submit.prevent.native="onSubmit">
            <el-row :gutter="30">
                <el-col :span="19">
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">{{ getRouteName($route) }}</span>
                            <form-language-switcher></form-language-switcher>
                        </div>
                        <el-form-item label="Nazwa robocza"
                                      :error="errors['working_name']"
                                      required>
                            <el-input v-model="form['working_name']">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="Tagi z instagrama"
                                      :error="errors['working_name']"
                                      required>
                            <el-select v-model="form.tags"
                                       multiple
                                       filterable
                                       allow-create
                                       default-first-option
                                       placeholder="Wpisz tagi, po których mają być wyszukiwane zdjęcia">
                                <el-option v-for="item in []"
                                           :key="item.value"
                                           :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <photos-preview :form.sync="form"></photos-preview>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box">
                        <div class="box__header">
                            {{ $t('manage') }}
                        </div>
                        <el-form-item class="form__buttons" label-width="0">
                            <router-link :to="redirectRoute">
                                <el-button class="fluid form__button">{{ $t('cancel') }}</el-button>
                            </router-link>
                            <el-button @click="onSubmit"
                                       type="primary"
                                       class="fluid form__button"
                                       :loading="loading">
                                {{ $t('submit') }}
                            </el-button>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import {InstagramFolder} from '@/api/';
    import PhotosPreview from '@/views/Instagram/PhotosPreview'

    export default {
        data () {
            return {
                loading: false,
                redirectRoute: {name: 'Folders List'},
                form: {
                    photos: [],
                    tags: []
                },
                errors: {},
                service: InstagramFolder
            }
        },
        mounted () {
            this.fetchData()
        },
        components: {
            PhotosPreview
        },
        methods: {
            fetchData () {
                if (this.$route.params.id) {
                    this.service.get(this.$route.params.id).then(response => {
                        this.form = response.data
                    })
                }
            },
            onSubmit () {
                this.loading = true;
                const id = this.$route.params.id
                const service = id ? this.service.update(id, this.form) : this.service.save(this.form)
                service
                    .then(this.successHandler)
                    .catch(this.errorHandler)
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// FolderForm.vue?2670b5c0